// extracted by mini-css-extract-plugin
export default {"container":"SecondAunteficationTerminal_container__Hbscx","wrapper":"SecondAunteficationTerminal_wrapper__y4gdw"};